import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Clamp a value to 0–100 for percentage display. Treats 0–1 as decimal (e.g. 0.85 → 85). */
export function clampPct(v: unknown): number {
  const n = Number(v);
  if (isNaN(n)) return 0;
  const pct = n >= 0 && n <= 1 ? n * 100 : n;
  return Math.min(100, Math.max(0, pct));
}

export function normalizeDeviceMetrics(
  device: {
    cpuLoad?: number;
    memUsed?: number;
    memTotal?: number;
    diskUtil?: number;
  }
): {
  cpuLoad: number;
  memUsedPercent: number;
  diskUtil: number;
} {
  const clamp = (value: number) => Math.min(100, Math.max(0, value));

  const cpuLoad = clamp(device.cpuLoad ?? 0);
  const memUsedPercent = clamp(
    device.memUsed && device.memTotal
      ? (device.memUsed / device.memTotal) * 100
      : 0
  );
  const diskUtil = clamp(device.diskUtil ?? 0);

  return {
    cpuLoad,
    memUsedPercent,
    diskUtil,
  };
}
